<template>
  <!--  page starting div -->
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div v-else-if="is_no_records == 1">
      <GlobalEmptyRecord RouteName="Invoice">
        <template slot="title">
          <h2>Record your Credits</h2>
        </template>
        <template slot="content">
          <span style="color:gray"
            >The way to get rectified is to quit talking and to apply credits.</span
          >
        </template>
        <template slot="page"
          >Go to Invoice</template
        >
      </GlobalEmptyRecord>
    </div>
    <div class="start-page" v-else style="margin-top:-10px !important">
      <template v-if="CheckedCount == 0">
        <b-row class="px-pad border-bottom" style="height:42px">
          <b-col cols="8" class="px-0">
            <b-dropdown
              variant="link"
              class="index-filter-heading"
              size="sm"
              dropdown
              toggle-class="text-decoration-none"
              :text="filter_name"
            >
              <div class="dropdownitem-list">
                <b-dropdown-item
                  :class="{ filter_dropdown: true }"
                  :to="{
                    name: 'Credit',
                    query: {
                      page: 1,
                      show: 10,
                      search: '',
                      status: item.status_id,
                      sort: sort,
                      label: label,
                    },
                  }"
                  v-for="item in filter_list"
                  :key="item.status_id"
                  v-if="item.status_name != filter_name"
                  >{{ item.status_name }}</b-dropdown-item
                >
              </div>

              <b-dropdown-divider />
              <router-link
                class="event-link dropdown-item"
                fetchCreditDetails
                :to="{
                  name: 'FilterCreate',
                  params: {
                    title: 'Credit Note',
                    module: 'credit',
                    call: 'fetchCreditDetails',
                    route: 'cuscredit',
                  },
                }"
                >Add Custom Filter</router-link
              >
            </b-dropdown>
            <router-link
              class="event-link"
              v-if="status >= 100"
              :to="{
                name: 'FilterUpdate',
                params: {
                  id: getPresentValue(filter_list, 'status_name', filter_name),
                  title: 'Credit Note',
                  module: 'credit',
                  call: 'fetchCreditDetails',
                  route: 'cuscredit',
                },
              }"
            >
              <b-button size="xs" style="position:relative;bottom:4px;" variant="light">
                <i class="la la-edit la-lg"></i>
              </b-button>
            </router-link>
          </b-col>

          <b-col cols="4" class="text-right px-0">
            <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()">
              <i class="la la-refresh la-lg"></i>
            </b-button>
            <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
              <template slot="button-content">
                <i class="la la-navicon la-lg"></i>
              </template>
              <template v-if="RoutePermission(false, '', '', 'settings', 'export')">
                <b-dropdown-item @click="exportModal()">
                  <span class="no_caret_import la la-download mr-3"></span>Export CreditNote
                </b-dropdown-item>
                <b-dropdown-divider />
              </template>
              <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
              <div class="dropdownitem-block">
                <li class="ml-3">
                  <b-form-checkbox name="sales_person_name" v-model="sales_person_name" value="1"
                    >Sales Person</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="ref_no" v-model="ref_no" value="1"
                    >Reference No</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="place_of_supply" v-model="place_of_supply" value="2"
                    >Place of Supply</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="total_header_discount"
                    v-model="total_header_discount"
                    value="3"
                    >Total Discount</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="total_without_tax" v-model="total_without_tax" value="4"
                    >Total without Tax</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="crdt_tax" v-model="crdt_tax" value="5"
                    >Total Tax</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="adjusted_amount" v-model="adjusted_amount" value="6"
                    >Adjustment Amount</b-form-checkbox
                  >
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox name="cdn_reason_name" v-model="cdn_reason_name" value="8"
                    >Credit Reason</b-form-checkbox
                  >
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox name="used_amount" v-model="used_amount" value="10"
                    >Used Amount</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="refund_amount" v-model="refund_amount" value="11"
                    >Refund Amount</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="received_amount" v-model="received_amount" value="12"
                    >Received Amount</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="created_at" v-model="created_at" value="13"
                    >Created Time</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2 pb-2">
                  <b-form-checkbox name="updated_at" v-model="updated_at" value="14"
                    >Updated Time</b-form-checkbox
                  >
                </li>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" class="px-0">
          <b-row style="height:42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
              <!-- <b-button
              v-b-modal.creditupdate
              @click="modalPage = 'delete'"
              variant="light"
              class="text-left mr-2"
            >Bulk Update</b-button>-->
              <!--  delete the selected invoice -->
              <b-button
                size="sm"
                variant="light"
                class="text-left mr-2"
                @click="deletemodal"
                :disabled="!RoutePermission(false, '', '', 'credit', 'delete')"
              >
                <i
                  class="glyphicon glyphicon-trash"
                  v-b-tooltip="
                    !RoutePermission(false, '', 'invoice', 'credit', 'delete')
                      ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                      : ''
                  "
                ></i>
              </b-button>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
              <i
                v-on:click="
                  checkAll({
                    target: {
                      checked: false,
                    },
                  }),
                    (CheckedCount = 0),
                    (checkboxes1[0] = false)
                "
                class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
              ></i>
            </b-col>
          </b-row>
          <!-- search critertail alert -->
          <b-alert
            class="alert-transparent alert-shade mx-mar mt-3"
            :show="this.$route.params.search == '' ? false : true"
          >
            <router-link
              class="text-dark float-right"
              :to="{ name: 'Credit', query: { page: page, show: count, search: '' } }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span class="fw-semi-bold"
                >Customer Name / Customer ID / Company name / Credit No / Reference no :</span
              >
              {{ this.$route.query.search }}
            </p>
          </b-alert>
          <!--  section 3:filter dropdown section - to show the saved filter list and daterangepicker to filter -->

          <!--  section 4:show the list of table data form api -->

          <div
            :class="this.$route.params.search == '' ? 'table-responsive' : 'table_search'"
            id="scrollCol"
          >
            <table class="table table-hover index-table">
              <thead>
                <tr>
                  <th style="width:54px !important">
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        id="checkboxall"
                        v-model="checkboxes1[0]"
                        @change="(event) => checkAll(event)"
                      />
                      <label for="checkboxall" />
                    </div>
                  </th>
                  <th style="min-width:85px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'crdt_no',
                          custom: custom,
                        },
                      }"
                    >
                      ID
                      <small class="text-muted" v-if="label == 'crdt_no'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:200px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'cus_name',
                          custom: custom,
                        },
                      }"
                    >
                      Customer
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:180px !important" v-if="sales_person_name == 1">
                    Sales Person
                  </th>
                  <th style="min-width:200px !important" v-if="place_of_supply == 2">
                    Place of supply
                  </th>
                  <th style="min-width:200px !important" v-if="cdn_reason_name == 8">
                    Credit Reason
                  </th>
                  <th style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'crdt_date',
                          custom: custom,
                        },
                      }"
                    >
                      Date
                      <small class="text-muted" v-if="label == 'crdt_date'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="min-width:135px !important" v-if="ref_no == 1">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'ref_no',
                          custom: custom,
                        },
                      }"
                    >
                      Ref No.
                      <small class="text-muted" v-if="label == 'ref_no'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th
                    style="min-width:140px !important"
                    v-if="total_without_tax == 4"
                    class="text-right"
                  >
                    Without Tax
                  </th>
                  <th style="min-width:140px !important" v-if="crdt_tax == 5" class="text-right">
                    Tax
                  </th>
                  <th
                    style="min-width:140px !important"
                    v-if="total_header_discount == 3"
                    class="text-right"
                  >
                    Discount
                  </th>
                  <th
                    style="min-width:140px !important"
                    v-if="adjusted_amount == 6"
                    class="text-right"
                  >
                    Adjusted Amt.
                  </th>
                  <th
                    style="min-width:140px !important"
                    v-if="used_amount == 10"
                    class="text-right"
                  >
                    Used Amt.
                  </th>
                  <th
                    style="min-width:140px !important"
                    v-if="refund_amount == 11"
                    class="text-right"
                  >
                    Refund Amt.
                  </th>
                  <th
                    style="min-width:140px !important"
                    v-if="received_amount == 12"
                    class="text-right"
                  >
                    Received Amt.
                  </th>
                  <th style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'crdt_status_name',
                          custom: custom,
                        },
                      }"
                    >
                      Status
                      <small class="text-muted" v-if="label == 'crdt_status_name'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th class="text-right" style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'total_credit_amount',
                          custom: custom,
                        },
                      }"
                    >
                      Amount
                      <small class="text-muted" v-if="label == 'total_credit_amount'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th class="text-right" style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'available_amount',
                          custom: custom,
                        },
                      }"
                    >
                      Balance
                      <small class="text-muted" v-if="label == 'available_amount'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:300px !important" v-if="created_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'created_at',
                          custom: custom,
                        },
                      }"
                    >
                      Created Time
                      <small class="text-muted" v-if="label == 'created_at'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:300px !important" v-if="updated_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'updated_at',
                          custom: custom,
                        },
                      }"
                    >
                      Updated Time
                      <small class="text-muted" v-if="label == 'updated_at'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th class="text-right" style="width:30px !important"></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="8" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>
                      <div class="abc-checkbox index-checkbox text-left">
                        <input
                          type="checkbox"
                          v-model="checkboxes1[index + 1]"
                          :id="'checkbox' + (index + 1)"
                          :true-value="list.crdt_hdr_id"
                          :value="list.crdt_hdr_id"
                          @change="(event) => changeCheck(event, 'checkboxes1', index + 1)"
                        />
                        <label :for="'checkbox' + (index + 1)" />
                      </div>
                    </td>
                    <td v-if="$permissionDenied.indexOf('CreditView') == -1" class="text-nowrap">
                      <router-link
                        class="event-link theme-text-color"
                        :to="{ name: 'CreditView', params: { id: list.crdt_hdr_id } }"
                        >{{ list.crdt_no }}</router-link
                      >
                    </td>
                    <td v-else class="theme-text-color text-nowrap">{{ list.crdt_no }}</td>
                    <td style="max-width:200px !important">
                      <span class="text">{{ list.cus_name }}</span>
                    </td>
                    <td v-if="sales_person_name == 1" style="width:180px !important">
                      <span class="text">{{ list.sales_person_name }}</span>
                    </td>
                    <td v-if="place_of_supply == 2">
                      {{
                        getDetails($AppDetails.state_details, list.place_of_supply, "state_name")
                      }}
                    </td>
                    <td v-if="cdn_reason_name == 8" style="width:200px !important">
                      <span class="text">{{ list.cdn_reason_name }}</span>
                    </td>
                    <td>{{ getDateFormat(list.crdt_date) }}</td>

                    <td v-if="ref_no == 1" class="text-nowrap">{{ list.ref_no }}</td>
                    <td v-if="total_without_tax == 4" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.total_without_tax).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td v-if="crdt_tax == 5" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.crdt_tax).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td v-if="total_header_discount == 3" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.total_header_discount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td v-if="adjusted_amount == 6" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.adjusted_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>

                    <td v-if="used_amount == 10" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.used_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td v-if="refund_amount == 11" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.refund_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td v-if="received_amount == 12" class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.received_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td>{{ list.crdt_status_name }}</td>
                    <td class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.total_credit_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(list.available_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td v-if="created_at">
                      <span class="text">{{ displayDateTime(list.created_at) }}</span>
                    </td>
                    <td v-if="updated_at">
                      <span class="text">{{ displayDateTime(list.updated_at) }}</span>
                    </td>
                    <td class="text-right">
                      <router-link
                        v-if="
                          RoutePermission(false, '', 'bill', 'credit', 'update') &&
                            list.crdt_status != '6'
                        "
                        class="event-link theme-text-color text-decoration-none"
                        :to="{ name: 'CreditUpdate', params: { id: list.crdt_hdr_id } }"
                      >
                        <i
                          class="la la-edit la-lg theme-text-color table-hover-visible"
                          v-if="list.crdt_status != '6'"
                        ></i>
                      </router-link>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="lists.length > 0"
        style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="5" md="6" lg="6" sm="8" cols="8" class="mt-2 pt-1 px-0">
          <nav class="float-left">
            <p>
              Showing {{ total_count != 0 ? (page - 1) * count + 1 : 0 }} to
              {{ (page - 1) * show + lists.length }} of {{ total_count }} entries
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  size="xs"
                  :show="false"
                  :text="count"
                  left
                >
                  <router-link
                    :to="{
                      name: 'Credit',
                      query: {
                        page: 1,
                        show: 10,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 10"
                      >10</b-dropdown-item-button
                    >
                  </router-link>
                  <router-link
                    :to="{
                      name: 'Credit',
                      query: {
                        page: 1,
                        show: 25,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 25"
                      >25</b-dropdown-item-button
                    >
                  </router-link>
                  <router-link
                    :to="{
                      name: 'Credit',
                      query: {
                        page: 1,
                        show: 50,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 50"
                      >50</b-dropdown-item-button
                    >
                  </router-link>
                </b-dropdown>
              </span>
              rows per page
            </p>
          </nav>
        </b-col>
        <b-col
          xl="2"
          md="2"
          lg="2"
          sm="4"
          cols="4"
          style="text-align: center;"
          class="mt-2 pt-1 px-0"
        >
          <div v-if="arrow">
            <a @click="left('#scrollCol')" class="mr-2">
              <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
            </a>
            <a @click="right('#scrollCol')">
              <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
            </a>
          </div>
        </b-col>
        <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
          <template v-if="show < total_count">
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page - 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'Credit',
                      query: {
                        page: 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >First</router-link
                  >
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page - 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                      >Previous</router-link
                    >
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page + 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                      >Next</router-link
                    >
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'Credit',
                      query: {
                        page: Math.ceil(total_count / count),
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Last</router-link
                  >
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Credit',
                        query: {
                          page: page + 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </template>
        </b-col>
      </b-row>
      <b-modal
        id="creditdelete"
        size="sm"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        ok-title="Yes"
        title="Bulk Delete-Credit Notes"
      >
        <p>Are you sure about deleting the selected Credit(s)?</p>
      </b-modal>
      <b-modal
        id="creditupdate"
        size="md"
        body-class="bg-white"
        cancel-title="cancel"
        cancel-variant="light"
        ok-title="Update"
        title="Bulk Update-Credit Notes"
      >
        <p>Choose a field from the dropdown and update with new information.</p>
        <b-row>
          <b-col>
            <b-form-group>
              <select
                name="update"
                class="form-control text-right"
                style="padding:2px;background: #f7f7f7;"
                placeholder="Select a field"
              >
                <option value="0"></option>
                <option value="1">Reference#</option>
                <option value="1">PDF template</option>
                <option value="2">Sales person</option>
                <option value="3">Customer Notes</option>
                <option value="4">Terms and conditions</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col style="max-width:500px">
            <b-form-input type="text" size="sm" name="type" />
          </b-col>
        </b-row>
        <span
          >Note: All the selected invoices will be updated with new information and you cannot undo
          this.</span
        >
      </b-modal>
      <GlobalExportModal
        v-if="export_modal"
        :data="export_data"
        :columns="export_xl"
        :file_name="'Credit Note'"
        @downloaded="export_modal = false"
      />
      <!--  bulk delete modal -->
      <DeleteRecord
        v-on:setDelete="getDelete"
        :value="value"
        module="credit"
        content="The selected credit(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
      ></DeleteRecord>
      <LogRecord :message="logrecords"></LogRecord>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import { notificationMixin } from "@/mixins/notification";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import RecordNotFound from "@/pages/Error/RecordNotFound";
function getPageCredits(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status = routeTo.query.status || store.state.credit.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";
  store
    .dispatch("credit/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom,
    })
    .then((response) => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true,
        });
      } else {
        store.dispatch("credit/fetchCreditDetails");
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable, formatDate],
  props: {
    page: {
      type: Number,
      required: true,
    },
    show: {
      type: Number,
      required: true,
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number],
  },
  name: "Credit",
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound,
  },
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        ID: "crdt_no",
        "Customer Name": "cus_name",
        "Sales person": "sales_person_name",
        "Credit Reason": "cdn_reason_name",
        Date: "crdt_date",
        Number: "ref_no",
        "Total without Tax(BCY)": "total_without_tax",
        "Total without Tax(FCY)": "export_total_without_tax",
        "Total Tax(BCY)": "crdt_tax",
        "Total Tax(FCY)": "export_crdt_tax",
        "Total Discount(BCY)": "total_header_discount",
        "Total Discount(FCY)": "export_total_header_discount",
        "Adjusted Amount(BCY)": "adjusted_amount",
        "Adjusted Amount(FCY)": "export_adjusted_amount",
        "Used Amount(BCY)": "used_amount",
        "Used Amount(FCY)": "export_used_amount",
        "Refund Amount(BCY)": "refund_amount",
        "Received Amount(FCY)": "export_received_amount",
        "Amount(BCY)": "total_credit_amount",
        "Amount(FCY)": "total_credit_amount",
        "Balance(BCY)": "export_available_amount",
        "Balance(FCY)": "export_available_amount",
        Status: "crdt_status_name",
        "Created Time": "created_at",
        "Updated Time": "updated_at",
      },
      ref_no: "",
      sales_person_name: "",
      place_of_supply: "",
      total_header_discount: "",
      total_without_tax: "",
      crdt_tax: "",
      used_amount: "",
      received_amount: "",
      refund_amount: "",
      adjusted_amount: "",
      cdn_reason_name: "",
      logrecords: "", // to show log of popup funcitons
      value: [],
      // locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      total: 10,
      created_at: "",
      updated_at: "",
      checkboxes1: [],
      CheckedCount: 0,
      modalPage: "",
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  methods: {
    getrefreshList() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("credit/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom,
        })
        .then(() => {
          this.$router.push({
            name: this.$route.name,
            query: {
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status,
            },
          });
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("credit/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom,
        })
        .then(() => {
          if (this.status_code != 200) {
            window.Messenger().post({
              extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true,
            });
          } else {
            this.$root.$emit("bv::show::modal", "exportdata");
            return this.export;
          }
        });
      return response;
    },

    //  detelted record details
    getDelete() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;

      this.$router
        .push({
          name: this.$route.name,
          query: {
            page: currentPage,
            show: show,
            search: search,
            status: status,
            update: update_status,
            sort: sort,
            label: label,
          },
        })
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);

          this.$route.params.sort = sort;
          await this.$router.push({
            query: {
              page: this.page,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status,
            },
          });
        });
      if (this.status_code == 200) {
        this.logrecords =
          this.message.message.length == 0 ? this.message.success : this.message.message;
        this.$root.$emit("bv::show::modal", "loglist");
      } else {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.message.message,
          type: this.message.type,
          showCloseButton: true,
        });
      }
    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter((item) => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    // to filter the json data - to get any particular data from json
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;
      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] = ev.target.checked == true ? value.crdt_hdr_id : false;
      });
      this.CheckedCount =
        ev.target.checked == true ? (this.page - 1) * this.show + this.lists.length : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var crdt_hdr_ids = this.checkboxes1;
      crdt_hdr_ids = crdt_hdr_ids.filter((item) => item !== false);
      // check all if page length matches
      if (crdt_hdr_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
  },

  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
    // this.initializationMessengerCode();
    // Messenger.options = {
    //   extraClasses: this.locationClasses,
    //   theme: "air"
    // };
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
    store.state.credit.index_status =
      store.state.settings.status_code != 404 ? store.state.credit.index_status : "";
    store.dispatch("credit/fetchCreditDetails");
    getPageCredits(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store.state.credit.index_status = "";
    getPageCredits(routeTo, next);
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
  beforeRouteLeave(to, from, next) {
    store.state.credit.credit_index_history = from.fullPath;
    store.state.credit.index_status = from.params.status;
    store.state.settings.status_code = "";
    next();
  },

  computed: {
    ...mapState({
      lists: (state) => state.credit.lists,
      total_count: (state) => state.credit.total_count,
      is_no_records: (state) => state.credit.is_no_records, // to check for an record in the database
      count: (state) => state.credit.count,
      search_criteria: (state) => state.credit.search_criteria,
      filter_list: (state) => state.credit.filter_list, // to show the  dropdown of filter list name inside the table file: credit.js
      filter_name: (state) => state.credit.filter_name, // to show the  name of the selected filter list name inside the table file: credit.js
      message: (state) => state.credit.log_details,
      credit_details: (state) => state.credit.details,
      export: (state) => state.credit.export,
      status_code: (state) => state.credit.status_code,
      status_message: (state) => state.credit.status_message,
      status_type: (state) => state.credit.status_type,
    }),
    ...mapGetters(["isallowedroutes", "role_name"]),
  },
};
</script>
